<template>
  <Dialog
    ref="dialogRef"
    :open="open"
    @update:open="handleUpdateOpen"
    :variant="variant || steps[currentStep]?.variant"
    :background="background || steps[currentStep]?.background"
    :size="size || steps[currentStep]?.size"
    :title="steps[currentStep]?.title"
    :description="steps[currentStep]?.description"
    :withSearch="steps[currentStep]?.withSearch"
    :showClear="steps[currentStep]?.showClear"
    :withBackdropButton="withBackdropButton"
  >
    <slot />
    <template v-if="steps[currentStep]?.header || $slots.header" #header>
      <slot name="header" :step="steps[currentStep]" />
    </template>
    <template v-if="steps[currentStep]?.search" #search>
      <slot
        name="search"
        :step="steps[currentStep]"
        :searchProps="steps[currentStep].searchProps"
      />
    </template>
    <template v-if="steps[currentStep]?.content" #content>
      <slot
        name="content"
        :step="steps[currentStep]"
        :props="steps[currentStep].props"
        :forward="forward"
        :handleGoToStep="handleGoToStep"
        :handleStepForward="handleStepForward"
        :handleStepBack="handleStepBack"
      />
    </template>
    <template v-if="steps[currentStep]?.footer || $slots.footer" #footer>
      <slot
        name="footer"
        :step="steps[currentStep]"
        :footerProps="steps[currentStep].footerProps"
        :handleGoToStep="handleGoToStep"
        :handleStepForward="handleStepForward"
        :handleStepBack="handleStepBack"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { Dialog } from "@/SharedComponents/Dialog";
import { Steps, useSteps } from "@/Composables/useSteps";

const dialogRef = ref(null);

const emit = defineEmits(["update:open"]);

const props = defineProps({
  open: { type: Boolean, default: undefined },
  steps: { type: Steps, required: true },
  variant: { type: String, required: false },
  background: { type: String, required: false },
  withBackdropButton: { type: Boolean, default: false },
  size: { type: [String, Number], required: false },
});

onMounted(() => {
  if (props.open) {
    reset();
  }
});

function handleUpdateOpen(open) {
  if (open) {
    reset();
  }
  emit("update:open", open);
}

const {
  forward,
  currentStep,
  handleGoToStep,
  handleStepForward,
  handleStepBack,
  reset,
} = useSteps(props.steps);

defineExpose({
  currentStep,
  handleGoToStep,
  handleStepForward,
  handleStepBack,
  query: computed(() => dialogRef.value?.query),
  clearQuery: () => dialogRef.value?.clearQuery(),
  close: () => dialogRef.value?.close(),
});
</script>
